/*globals Sentry:false */

const wrapped = function(code){
   try{
      code();
   } catch(err){
      if(typeof Sentry !== 'undefined') Sentry.captureException(err);
      else window.console.error(err);
   }

}

export { wrapped };
